import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconCart.module.css';

const IconCart = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C9.37665 2 7.25 4.12665 7.25 6.75V8.00952C5.5721 8.13752 4.25001 9.54008 4.25 11.2507V22H19.75V11.2507C19.75 9.54009 18.4279 8.13752 16.75 8.00952V6.75C16.75 4.12665 14.6234 2 12 2ZM16.4994 9.5L7.5006 9.5C6.53413 9.5 5.75 10.2841 5.75 11.2507L5.75 20.5H18.25V11.2513C18.25 10.2848 17.4659 9.5 16.4994 9.5ZM15.25 8V6.75C15.25 4.95507 13.7949 3.5 12 3.5C10.2051 3.5 8.75 4.95507 8.75 6.75V8H15.25Z"
        fill="black"
      />
    </svg>
  );
};

IconCart.defaultProps = { className: null };

IconCart.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconCart;
